export default __webpack_public_path__ + "eabdd47a79cc1a899960d33768725af3.svg";